module.exports = __webpack_public_path__ + "static/media/heidimood.7f041eec.jpeg";